import {CalendarIcon} from '@heroicons/react/outline'
import React from 'react'
import SecondaryButton from '../../../ui/SecondaryButton';
import gql from 'graphql-tag';
import {useMutation} from '@apollo/client';
import {showError, showInfo} from '../../../ui/ToastNotification';
import {GraphQLError} from 'graphql';

export default function DashboardActions() {

  const [rebuildEvents, {loading}] = useMutation(rebuildEventsMutation);
  const [closeInvoices, {loading: closeInvoicesLoading}] = useMutation(closeInvoicesMutation);


  const onRebuild = React.useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    rebuildEvents().then(
      () => {
        showInfo('All events have been rebuilt');
      },
      (apolloError) => {
        apolloError.graphQLErrors.map((error: GraphQLError) => showError(error.message));
      }
    );
  }, [rebuildEvents]);

  const onCloseInvoices = React.useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    closeInvoices().then(
      () => {
        showInfo('Closing of all open platform invoices launched');
      },
      (apolloError) => {
        apolloError.graphQLErrors.map((error: GraphQLError) => showError(error.message));
      }
    );
  }, [rebuildEvents]);

  return (
    <>
      <div
        className="rounded-lg overflow-hidden shadow divide-y divide-gray-dark sm:divide-y-0 sm:grid sm:grid-cols-2 gap-x-2">
        <div className="rounded-lg relative group bg-white p-6">
          <div>
            <span className="rounded-lg inline-flex ring-4 ring-white">
              <CalendarIcon className="h-6 w-6" aria-hidden="true"/>
            </span>
          </div>
          <div className="mt-8">
            <h3 className="text-lg font-medium"> Rebuild events</h3>
            <p className="mt-2 text-sm text-gray-dark">
              Rebuild events in the database. This action will read and save the events again, converting old complex
              objects to new ones in the process.
            </p>
            <p className="mt-2 text-sm">
              It is safe to run this action multiple times.
            </p>
          </div>
          <SecondaryButton short={true} loading={loading}
                           onClick={(e: React.MouseEvent<HTMLButtonElement>) => onRebuild(e)}
                           className="absolute top-6 right-6">
            Rebuild
          </SecondaryButton>
        </div>
        <div className="rounded-lg relative group bg-white p-6">
          <div>
            <span className="rounded-lg inline-flex ring-4 ring-white">
              <CalendarIcon className="h-6 w-6" aria-hidden="true"/>
            </span>
          </div>
          <div className="mt-8">
            <h3 className="text-lg font-medium"> Close platform invoices</h3>
            <p className="mt-2 text-sm text-gray-dark">
              Close all open platform invoices
            </p>
            <p className="mt-2 text-sm">
              It is safe to run this action multiple times.
            </p>
          </div>
          <SecondaryButton short={true} loading={closeInvoicesLoading}
                           onClick={(e: React.MouseEvent<HTMLButtonElement>) => onCloseInvoices(e)}
                           className="absolute top-6 right-6">
            Close
          </SecondaryButton>
        </div>
      </div>
    </>
  )
}

const rebuildEventsMutation = gql`
  mutation RebuildEvents {
    rebuildEvents
  }
`;

const closeInvoicesMutation = gql`
  mutation CloseInvoices {
    closeOpenPlatformInvoices
  }
`;
